<!--<ngx-loading-bar></ngx-loading-bar>-->
<!--The content below is only a placeholder and can be replaced.-->
<p-toast></p-toast>
<app-sidebar-component> </app-sidebar-component>
<app-header-component></app-header-component>
<!-- START PAGE-CONTAINER -->
<div class="page-container" [class.no-header]="isAuthPage">
  <!-- START PAGE CONTENT WRAPPER -->
  <router-outlet>
    <ngx-spinner
      bdColor="rgba(51, 51, 51, 0.8)"
      size="medium"
      color="#fff"
      type="ball-clip-rotate-multiple"
    ></ngx-spinner>
  </router-outlet>
</div>

<!-- Route transition loader: shown while a lazy-loaded module is fetched -->
<ngx-spinner
  name="routeLoader"
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate-multiple"
></ngx-spinner>
